$("form[data-form-submit-preventdefault]").submit(function (e) {
    e.preventDefault();
});

//submit form if the user uses the enter key
$('input[type=text], input[type=search], input[type=tel], input[type=email], input[type=password]').keypress(function (e) {
    if (e.which == 13) {
        $(this).closest("form").submit();
        return false;
    }
});

$('[data-form-clear-input-trigger]').on('click', function () {
    var sourceElementId = $(this).attr('data-form-clear-input-trigger')

    if (sourceElementId) {
        var sourceElement = $(sourceElementId);
        var inputs = $(sourceElement).find(':input');
        clearInputs(inputs);
    }
    else {
        var inputs = $(this).closest('form').find(':input');
        clearInputs(inputs);
    }

    $(this).closest("form").submit();
});

window.clearInputs = function clearInputs(inputElements) {
    $(inputElements).each(function (index) {
        if (isCheckBased($(this))) {
            if ($(this)[0].hasAttribute('data-form-default')) {
                $(this).prop('checked', true);
            }
            else {
                $(this).prop('checked', false);
            }
        }
        else {
            $(this).val('');
        }


    });
}

function serializeFormWithExclusions(form) {
    return $(form).find(':input').not('[data-form-exclude]').serialize();
}
